<template>
  <div class="MediaContainer">
    <slot />
  </div>
</template>

<script type="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    fill: {
      type: String,
      default: '#333333'
    }
  },
  computed: {
    cssVars () {
      return {
        '--mediacontainer_background': this.fill
      }
    }
  }
})
</script>

<style lang="scss">
  .MediaContainer {
    position: relative;
    background-color: var(--mediacontainer_background);

    & > *:last-child {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>
